import { render } from "./AlertLogTable.vue?vue&type=template&id=57b850e0&scoped=true"
import script from "./AlertLogTable.vue?vue&type=script&lang=js"
export * from "./AlertLogTable.vue?vue&type=script&lang=js"

import "./AlertLogTable.vue?vue&type=style&index=0&id=57b850e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b850e0"]])

export default __exports__